import { Transition } from '@headlessui/react';
import { useCallback, useEffect, useState } from 'react';

import NotificationToast from 'components/NotificationToast';
import useToast from 'contexts/ToastProvider/useToast';

import { NotificationToastItem } from './types';
import { placeholderTransformAnimations, TOAST_TTL, toastTransformAnimations } from './utils';

const NotificationToastListItem = ({
  id,
  variant,
  title,
  icon,
  description,
  autoDismiss = false,
  onClose,
  onPrimaryAction,
  onSecondaryAction,
  primaryActionText,
  secondaryActionText,
}: NotificationToastItem) => {
  const { removeToast } = useToast();
  const [isVisible, setIsVisible] = useState(false);

  const initClose = useCallback(() => {
    setIsVisible(false);
    if (onClose) onClose();
  }, [onClose]);

  useEffect(() => {
    setIsVisible(true);

    if (!autoDismiss) return;

    const toastTimeout = setTimeout(initClose, TOAST_TTL);

    return () => clearTimeout(toastTimeout);
  }, [autoDismiss, initClose]);

  const deleteToast = () => removeToast(id);

  return (
    <Transition show={isVisible} className="max-w-full">
      <Transition.Child {...placeholderTransformAnimations} afterLeave={deleteToast} className="overflow-y-hidden">
        <Transition.Child
          {...toastTransformAnimations}
          className="flex justify-end"
          data-testid={`notification-toast-${id}`}
        >
          <NotificationToast
            variant={variant}
            className="mt-2"
            onClose={initClose}
            icon={icon}
            description={description}
            onPrimaryAction={onPrimaryAction}
            onSecondaryAction={onSecondaryAction}
            primaryActionText={primaryActionText}
            secondaryActionText={secondaryActionText}
          >
            {title}
          </NotificationToast>
        </Transition.Child>
      </Transition.Child>
    </Transition>
  );
};

export default NotificationToastListItem;
